import { useEffect, useRef } from 'react';
import { Button, Stack, Typography } from '@mui/material';

import {
    attachSafariDurationFix,
    canPlayLeadAudio,
    playbackMime,
} from './leadOriginAudioUtils';

export function LeadOriginAudio({
    url,
    contentType,
    downloadName,
}: {
    url: string;
    contentType: string;
    downloadName: string;
}) {
    const audioRef = useRef<HTMLAudioElement>(null);
    const mime = playbackMime(contentType);
    const playable = canPlayLeadAudio(contentType);

    useEffect(() => {
        const el = audioRef.current;
        if (!el || !playable) return;
        return attachSafariDurationFix(el);
    }, [url, playable]);

    if (!playable) {
        return (
            <Stack spacing={1}>
                <Typography variant="body2" color="text.secondary">
                    This recording can&apos;t play in this browser. Download it to listen.
                </Typography>
                <Button href={url} download={downloadName}>
                    Download origin file
                </Button>
            </Stack>
        );
    }

    return (
        <audio
            ref={audioRef}
            controls
            playsInline
            preload="metadata"
            style={{ width: '100%' }}
        >
            <source src={url} type={mime} />
        </audio>
    );
}
